<template>
  <div id="import-xml-cte-fical">
    <BreadCrumb :items="breadcrumbItems" />
    <v-card elevation="1" class="pa-2">
      <v-card-title class="header d-flex justify-space-between align-center">
        <h1 class="pa-0">Importação XML das Ctes</h1>
        <div class="d-flex">
          <v-btn elevation="2" class="mx-2" color="success" @click="isUploadDialogOpen = true" large>
            Upload XML
          </v-btn>
        </div>
      </v-card-title>

      <v-expansion-panels accordion class="mt-2 mb-10 px-4">
        <v-expansion-panel class="elevation-1">
          <v-expansion-panel-header color="#f2f2f2" class="px-4">
            <span>Filtrar por</span>
            <template v-slot:actions>
              <v-icon color="black"> mdi-chevron-down </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="mt-2 pb-1">
              <v-col cols="12" md="4">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedImportDateInitial"
                      label="Data Importação Início"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="importDateInitial" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedImportDateEnd"
                      label="Data Importação Fim"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="importDateEnd" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="userId"
                  :items="users"
                  label="Usuário responsável / Importado por"
                  item-text="name"
                  item-value="userId"
                ></v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="key"
                  label="Chave CTE"
                  v-mask="'############################################'"
                  type="text"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-select
                  v-model="statusId"
                  :items="getSummaryStatus"
                  label="Status"
                  item-text="name"
                  item-value="id"
                ></v-select>
              </v-col>

              <v-col cols="12" md="12" class="d-flex justify-end align-center">
                <v-btn @click="cleanFilter()" :disabled="!hasFilters" elevation="2" color="red" class="mx-2 text-white">
                  Limpar Filtros
                </v-btn>
                <v-btn
                  :loading="isImportsLoading"
                  :disabled="!hasFilters"
                  elevation="2"
                  color="green"
                  class="text-white"
                  @click="fetchAllImportsXml()"
                >
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-data-table
        class="mt30 px-5"
        :headers="columnsOptions"
        :items="importsXml"
        :loading="isImportsLoading"
        :items-per-page="pageSize"
        @update:items-per-page="changeItemsPerPage"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 50],
          itemsPerPageText: 'Itens por página'
        }"
        no-data-text="Nenhum resultado encontrado"
      >
        <template #[`item.createdAt`]="{ item }">
          <span> {{ transformDate(item.createdAt) }}</span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex" v-if="item.statusName != 'Processando'">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <ViewSVG v-bind="attrs" v-on="on" @click="openDetailsDialog(item.id)" />
              </template>
              <span>Detalhes</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <v-pagination v-model="pageNumber" :length="totalPages" :total-visible="7"></v-pagination>
    </v-card>
    <upload-xml-cte :isOpen.sync="isUploadDialogOpen" @shouldUpdateList="fetchAllImportsXml()" />
    <import-xml-cte-details :isOpen.sync="isDetailsDialogOpen" :cteXmlId="cteXmlId" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BreadCrumb from '@/components/BreadCrumb.vue';
import ViewSVG from '@/assets/img/view.svg';
import UploadXmlCte from '@/components/AccountsReceivable/UploadXmlCteDialog.vue';
import ImportXmlCteDetails from '@/components/AccountsReceivable/ImportXmlCteDetails.vue';

export default {
  name: 'ImportsXmlCte',
  components: {
    BreadCrumb,
    UploadXmlCte,
    ImportXmlCteDetails,
    ViewSVG
  },
  data: () => ({
    isImportsLoading: true,
    isStatusLoading: true,
    isUploadDialogOpen: false,
    isDetailsDialogOpen: false,
    menu1: false,
    menu2: false,
    key: null,
    importDateInitial: null,
    importDateEnd: null,
    userId: null,
    statusId: null,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 0,
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },
      {
        text: 'Fiscal',
        disabled: true
      },
      {
        text: 'Importação XML',
        disabled: true
      }
    ],
    columnsOptions: [
      {
        value: 'responsibleUserName',
        text: 'IMPORTADO POR',
        sortable: false
      },
      {
        value: 'createdAt',
        text: 'DATA IMPORTAÇÃO',
        sortable: false
      },
      {
        value: 'statusName',
        text: 'STATUS',
        sortable: false
      },
      {
        value: 'actions',
        text: 'AÇÕES',
        sortable: false
      }
    ],
    importsXml: [],
    senders: [],
    users: [],
    getSummaryStatus: [],
    cteXmlId: null
  }),

  computed: {
    formattedImportDateInitial() {
      let date = this.importDateInitial;
      return this.formatDate(date);
    },
    formattedImportDateEnd() {
      let date = this.importDateEnd;
      return this.formatDate(date);
    },

    formattedAuthorizationDateInitial() {
      let date = this.authorizationDateInitial;
      return this.formatDate(date);
    },

    formattedAuthorizationDateEnd() {
      let date = this.authorizationDateEnd;
      return this.formatDate(date);
    },

    getTheLastThirtyDays() {
      const now = new Date();
      const currentDay = now;
      const thirtyDayAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30);

      return {
        thirtyDayAgo: thirtyDayAgo.toISOString().slice(0, 10),
        currentDay: currentDay.toISOString().slice(0, 10)
      };
    },

    hasFilters() {
      if (this.importDateInitial || this.importDateEnd || this.userId || this.key || this.statusId) {
        return true;
      }
      return false;
    }
  },

  created() {
    this.filterTheLastThirtyDays();
    this.fetchAllImportsXml();
    this.fetchAllSummaryData();
    this.fetchAllUsers();
  },

  watch: {
    pageNumber: {
      handler() {
        this.fetchAllImportsXml();
      }
    }
  },

  methods: {
    ...mapActions('ImportXmlStore', ['fetchImportsXml', 'getSummaryStatusImport']),
    ...mapActions('UserStore', ['fetchListUsers']),

    async fetchAllImportsXml() {
      try {
        this.isImportsLoading = true;
        const filters = this.getFilters();
        const { data, totalPages, totalRecords } = await this.fetchImportsXml(filters);
        this.totalPages = totalPages;
        this.totalRecords = totalRecords;

        this.importsXml = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.isImportsLoading = false;
      }
    },

    filterTheLastThirtyDays() {
      const { thirtyDayAgo, currentDay } = this.getTheLastThirtyDays;
      this.importDateInitial = thirtyDayAgo;
      this.importDateEnd = currentDay;
    },

    async fetchAllUsers() {
      try {
        const data = await this.fetchListUsers();
        this.users = data;
      } catch (err) {
        console.error(err);
      }
    },

    async fetchAllSummaryData() {
      this.isStatusLoading = true;
      try {
        const summaryStatus = await this.getSummaryStatusImport();
        this.getSummaryStatus = summaryStatus;
      } catch (err) {
        console.error(err);
      } finally {
        this.isStatusLoading = false;
      }
    },

    changeItemsPerPage(pageSize) {
      this.pageNumber = 1;
      this.pageSize = pageSize;
      this.fetchAllImportsXml();
    },

    openDetailsDialog(cteXmlId) {
      this.cteXmlId = cteXmlId;
      this.isDetailsDialogOpen = true;
    },

    getApprobation(approbation) {
      return approbation ? 'Aprovado' : 'Rejeitado';
    },

    formatDate(d) {
      if (d === null) return d;
      let dateObj = new Date(`${d}T00:00:00`);
      return dateObj.toLocaleDateString('pt-BR');
    },

    transformDate(date) {
      let dateObj = new Date(`${date}`);
      return `${dateObj.toLocaleDateString('pt-BR')} ${dateObj.toLocaleTimeString('pt-BR')}`;
    },

    getFilters() {
      return {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        createdAtStart: this.importDateInitial,
        createdAtEnd: this.importDateEnd,
        responsibleUserId: this.userId,
        statusId: this.statusId,
        accessKey: this.key
      };
    },

    cleanFilter() {
      this.importDateInitial = null;
      this.importDateEnd = null;
      this.userId = null;
      this.key = null;
      this.statusId = null;

      this.fetchAllImportsXml();
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.v-select.v-select--chips .v-select__selections {
  min-height: 50px;
}

::v-deep .v-data-table-header tr th {
  background-color: #e0e0e0 !important;
  border: 1px solid #e0e0e0;
}
</style>
